import React from 'react';
import PropTypes from 'prop-types';

import {
  Form,
  Button
} from 'semantic-ui-react';

import { getValue } from '_utils';
import { getKeyLicensePoolSelectionOptions } from '_utils/licensePools';

import BaseInputField from '_forms/baseInput';
import KeySourceField from '_forms/source';
import SessionLengthField from '_forms/sessionLengthField';

const CreateInstitutionKeyForm = ({
  data,
  institution,
  onChange,
  onCancel,
  onSubmit
}) => {

  const onFieldChange = (e, field) => onChange(field.name, getValue(field));
  const poolOptions = getKeyLicensePoolSelectionOptions(institution.license_pools);

  const selectedPool = institution.license_pools.find(p => p._id === data.license_pool_id);

  return (
    <Form onSubmit={ onSubmit }>
      <Form.Group widths='equal' >
        <KeySourceField
          width={ 8 }
          name='license_pool_id'
          value={ data.license_pool_id }
          options={ poolOptions }
          onChange={ onFieldChange }
          popup={ `From what license pool will this key draw?  Your options depend on what set of licenses you purchased.` }
        />
        <SessionLengthField
          width={ 8 }
          name='session_length_min'
          lengthInMinutes={ data.session_length_min }
          onChange={ onFieldChange }
        />
      </Form.Group>
      <Form.Group widths='equal'>
        <BaseInputField
          width={ 16 }
          name='description'
          type='text'
          value={ data.description }
          onChange={ onFieldChange }
          labelTxt='Description (optional)'
          popupTxt='Set a note for your reference.'
        />

      </Form.Group>
      <Button.Group>
        <Button onClick={ onCancel }>Cancel</Button>
        <Button.Or />
        {/* disabled={saveDisabled(props)} */}
        <Button positive type="submit" disabled={ !selectedPool || selectedPool.key_count < 1 } >Create Key</Button>
      </Button.Group>
    </Form>
  );
};

CreateInstitutionKeyForm.propTypes = {
  data: PropTypes.shape({
    license_pool_id: PropTypes.string,
    session_length_min: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired
  }).isRequired,
  institution: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CreateInstitutionKeyForm;



// WEBPACK FOOTER //
// ./webAdmin/forms/institutionKeyForm.js